import { useRetryCrawlRequestMutationApi } from '@aibees/elephant/api';
import { ROUTES } from '@aibees/elephant/router';
import { Icon, IconType } from '@aibees/shared/components';
import { NotificationMetadataStatus } from '@aibees/shared/features/notifications';
import { useNotificationStore } from '@aibees/shared/features/notifications/store';
import { classnames, jsonParse } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import { ServiceType } from '../service-card';
import * as Styled from './styles';
import * as SX from './sx';
import type { CrawlNotificationActionButtonProps as Props } from './types';

export const CrawlNotificationActionButton = memo(
  ({ className, item }: Props) => {
    const searchKey = 'value';
    const closeDrawer = useNotificationStore.useCloseDrawer();
    const metadata = jsonParse(item.message.metadata.metadata);

    const retryCrawlRequestApi = useRetryCrawlRequestMutationApi(
      item?.message.metadata.id
    );

    const route = useMemo(
      () =>
        item.message.metadata.group === 'PERSON'
          ? ROUTES.searchPeople
          : ROUTES.searchCompany,
      [item.message.metadata.group]
    );

    const icon: IconType =
      item.message.metadata.status === NotificationMetadataStatus.SUCCESS
        ? 'plus'
        : 'reload';

    const handleClick = () => {
      if (item.message.metadata.status === NotificationMetadataStatus.SUCCESS) {
        if (metadata.type === ServiceType.Analysis) {
          const queryString = new URLSearchParams({
            type: ServiceType.Analysis,
            value: item.message.metadata.link ?? '',
          }).toString();

          const url = `${ROUTES.home}?${queryString}`;
          window.open(url, '_blank');
        } else {
          const queryString = new URLSearchParams({
            [searchKey]: item.message.metadata.link ?? '',
          }).toString();

          const url = `${route}?${queryString}`;
          window.open(url, '_blank');
        }

        closeDrawer();
      } else if (
        item.message.metadata.status === NotificationMetadataStatus.FAILED
      ) {
        retryCrawlRequestApi.mutateAsync({});
      }
    };

    return (
      <Styled.Wrapper
        className={classnames('CrawlNotificationActionButton', className)}
        sx={SX.root}
        size="xsmall"
        variant="outlined"
        onClick={handleClick}
      >
        <Icon name={icon} size={18} color="grey.600" />
      </Styled.Wrapper>
    );
  }
);

CrawlNotificationActionButton.displayName = 'CrawlNotificationActionButton';
